module.exports = __webpack_public_path__ + "img/cookies-435296_1280.652a3ed3.png";